__turbopack_context__.v({
  "content": "QT542G_content",
  "imgContainer": "QT542G_imgContainer",
  "root": "QT542G_root",
  "textContainer": "QT542G_textContainer",
});
